export default {
  // @see https://github.com/colinfizgig/aframe_Components/blob/master/components/camera-cube-env.js

  /**
   * Specifies an envMap on an entity, without replacing any existing material
   * properties.
   */
  // computed: {
  //   ...mapState(['poly'])
  // },
  methods: {
    envMap () {
      //
      // eslint-disable-next-line prettier/prettier
      if (!AFRAME.components['env-map']) {
        AFRAME.registerComponent('env-map', {
          schema: {
            resolution: { type: 'number', default: 512 },
            distance: { type: 'number', default: 10000 },
            interval: { type: 'number', default: 100 },
            matOverride: { type: 'boolean', default: false },
            metalness: { type: 'float', default: 1.0 },
            roughness: { type: 'float', default: 0.0 },
            repeat: { type: 'boolean', default: true }
          },

          /**
           * Set if component needs multiple instancing.
           */
          multiple: false,

          /**
           * Called once when component is attached. Generally for initial setup.
           */
          init () {
            // debugger
            this.tick = AFRAME.utils.throttleTick(
              this.tick,
              this.data.interval,
              this
            )

            const renderTarget = new THREE.WebGLCubeRenderTarget(256, {
              format: THREE.RGBFormat,
              generateMipmaps: true,
              minFilter: THREE.LinearMipmapLinearFilter,
              encoding: THREE.sRGBEncoding
            })

            this.cam = new THREE.CubeCamera(1, this.data.distance, renderTarget)

            this.cam.renderTarget.texture.minFilter =
              THREE.LinearMipMapLinearFilter
            this.cam.renderTarget.texture.generateMipmaps = true
            // todo see if this.el can be used w/o querying selector
            // debugger
            // this.el = document.querySelector('[polygon]')
            this.el.object3D.add(this.cam)

            // this method does target for skinned meshes and unskinned
            this.loaded = this.el.addEventListener('model-loaded', () => {
              // console.log('model-loaded')
              this.redraw()
            })
          },

          tick (t, dt) {
            if (!this.done) {
              this.redraw(this.cam, this.el, this.el.getObject3D('mesh'))
              if (!this.data.repeat) {
                this.done = true
              }
            }
          },

          redraw () {
            // do we need this?
            // debugger
            if (
              this.el.getObject3D('mesh') != null &&
              AFRAME.scenes[0] != null &&
              this.data.matOverride
            ) {
              // Grab the mesh / scene.
              const obj = this.el.getObject3D('mesh')
              // Go over the submeshes and modify materials we want.

              obj.traverse((node) => {
                const myMesh = this.el.getObject3D('mesh')

                myMesh.visible = false

                // test works
                // todo turn this into it's own class
                // node.frustumCulled = false

                AFRAME.scenes[0].renderer.autoClear = true
                const camVector = new THREE.Vector3()
                this.el.object3D.getWorldPosition(camVector)
                this.cam.position.copy(this.el.object3D.worldToLocal(camVector))
                this.cam.update(
                  AFRAME.scenes[0].renderer,
                  this.el.sceneEl.object3D
                )

                if (node.type.includes('Mesh')) {
                  if (this.data.matOverride === true) {
                    node.material.metalness = this.data.metalness
                    node.material.roughness = this.data.roughness
                  } else {
                    node.material.metalness = null
                    node.material.roughness = null
                  }
                  node.material.envMap = this.cam.renderTarget.texture
                  node.material.needsUpdate = true
                }
                myMesh.visible = true
              })
            }
          },

          /**
           * Called when component is attached and when component data changes.
           * Generally modifies the entity based on the data.
           */
          update (oldData) {
            this.redraw()
          },

          /**
           * Called when a component is removed (e.g., via removeAttribute).
           * Generally undoes all modifications to the entity.
           */
          remove () {
            if (this.loaded) { this.loaded.remove() }
          },

          /**
           * Called on each scene tick.
           */
          // tick: function (t) { },

          /**
           * Called when entity pauses.
           * Use to stop or remove any dynamic or background behavior such as events.
           */
          pause () {},

          /**
           * Called when entity resumes.
           * Use to continue or add any dynamic or background behavior such as events.
           */
          play () {}
        })
      }
    }
  }
}
